export default __webpack_public_path__ + "static/media/banner.6f4a30c1.gif";